import React, { Component } from 'react';
import DataTable from 'react-data-table-component';

import './Campaigns.scss';

const campaigns = [
  { 
    channel: 'Facebook',
    status: true,
    campaign_name: 'TU_BAU_PROS_FB_APP',
    cost: '£2,314',
    impression: '227,693',
    clicks: '802',
    conversions: '4',
    cpa: "£19",
  },
  { 
    channel: 'Google Search',
    status: true,
    campaign_name: 'TU_BAU_SEARCH',
    cost: '£2,314',
    impression: '227,693',
    clicks: '802',
    conversions: '4',
    cpa: "£19",
  },
  { 
    channel: 'Facebook',
    status: true,
    campaign_name: 'TU_BAU_PROS_FB_APP',
    cost: '£2,314',
    impression: '227,693',
    clicks: '802',
    conversions: '4',
    cpa: "£19",
  },
  { 
    channel: 'Facebook',
    status: true,
    campaign_name: 'TU_BAU_PROS_FB_APP',
    cost: '£2,314',
    impression: '227,693',
    clicks: '802',
    conversions: '4',
    cpa: "£19",
  },
  { 
    channel: 'Google Display',
    status: true,
    campaign_name: 'SHOPPPPP',
    cost: '£2,314',
    impression: '227,693',
    clicks: '802',
    conversions: '4',
    cpa: "£19",
  },
  { 
    channel: 'Facebook',
    status: true,
    campaign_name: 'TU_BAU_PROS_FB_APP',
    cost: '£2,314',
    impression: '227,693',
    clicks: '802',
    conversions: '4',
    cpa: "£19",
  },
  { 
    channel: 'Facebook',
    status: true,
    campaign_name: 'TU_BAU_PROS_FB_APP',
    cost: '£2,314',
    impression: '227,693',
    clicks: '802',
    conversions: '4',
    cpa: "£19",
  },
];

const campaignsColumns = [
  {
    name: 'Channel',
    selector: 'Channel',
    sortable: true,
    right: true,
  },
  // {
  //   name: 'Ad ID',
  //   selector: 'Ad ID',
  //   sortable: true,
  //   right: true,
  // },
    {
      name: 'Ad name',
      selector: 'Ad name',
      wrap: true,
      sortable: true,
      right: true,
    },
    {
      name: 'Cost',
      selector: 'Cost',
      sortable: true,
      right: true,
    },
    {
      name: 'Impressions',
      selector: 'Impressions',
      sortable: true,
      right: true,
    },
    {
      name: 'Link clicks',
      selector: 'Linkclicks',
      sortable: true,
      right: true,
    },
    {
      name: 'Web Conversions',
      selector: 'WebsiteConversions',
      sortable: true,
      right: true,
    },
  ];


  const columns = [
    // {
    //   name: 'status',
    //   selector: 'status',
    //   sortable: true,
    //   right: true,
    // },
    {
      name: 'channel',
      selector: 'channel',
      sortable: true,
    },
    {
      name: 'campaign_name',
      selector: 'campaign_name',
      sortable: true,
      right: true,
    },
    {
      name: 'cost',
      selector: 'cost',
      sortable: true,
      right: true,
    },
    {
      name: 'impression',
      selector: 'impression',
      sortable: true,
      right: true,
    },
    {
      name: 'clicks',
      selector: 'clicks',
      sortable: true,
      right: true,
    },
    {
      name: 'conversions',
      selector: 'conversions',
      sortable: true,
      right: true,
    },
    {
      name: 'cpa',
      selector: 'cpa',
      sortable: true,
      right: true,
    },
  ];


const CampaignList = ({
  data, title
  }) => {
    return (
        <DataTable
            title={(title ? title : "Campaign List")}
            data={(data ? data : campaigns) }
            columns={(data ? campaignsColumns : columns ) }
            data={(data ? data : campaigns) }
            striped
            highlightOnHover
        />
    );
}

export default CampaignList;
